module.exports = "/images/vendor/vue-paycard/src/maestro.png?1be69146753c924e7b6bf89541d2bfc0";